import { createContext, useContext, useState } from 'react';

import type { Algorithm, ThemeType } from '@/v1/main/domain/config';
import { ConfigService } from '@/v1/main/domain/config';

interface ThemeContextProps {
    theme: ThemeType;
    algorithm: Algorithm;
    toggleTheme: () => void;
}

interface ThemeProviderProps {
    usecase: ConfigService;
    children: React.ReactNode;
}

const ThemeContext = createContext<ThemeContextProps | undefined>(undefined);

export const ThemeProvider = ({ usecase, children }: ThemeProviderProps) => {
    const [theme, setTheme] = useState(usecase.getTheme());
    const algorithm = usecase.getAlgorithm();
    const toggleTheme = () => {
        const val = usecase.toggleTheme();
        setTheme(val);
    };

    return (
        <ThemeContext.Provider value={{ theme, algorithm, toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (context === undefined) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
};
